/* eslint-disable react-hooks/rules-of-hooks */
import { FORM_MODES } from '@innovyze/stylovyze/lib/utils/constants';
import { Formik } from 'formik';
import { default as React, useState } from 'react';
import { StylovyzeFormContext } from './contexts/StylovyzeFormContext';
import { useListenStylovyzeForm } from './hooks/useListenStylovyzeForm';
function StylovyzeForm(props) {
    const { mode = FORM_MODES.EDIT, showSecondaryAction = false, ...formProps } = props;
    const [stylovyzeFields, setStylovyzeFields] = useState({});
    return (React.createElement(StylovyzeFormContext.Provider, { value: {
            mode,
            stylovyzeFields,
            setStylovyzeFields,
        } },
        React.createElement(Formik, { ...formProps, ...props }, (formikProps) => {
            useListenStylovyzeForm({
                showSecondaryAction,
                dirty: formikProps.dirty,
            });
            if (formProps.children) {
                return (formProps?.children(formikProps) ||
                    formProps?.children);
            }
            return null;
        })));
}
export default StylovyzeForm;
